import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ServerApi } from './server-api';
import { extractResponseBody } from '@lib/utils';


export interface IReferralInfo {
  referrer_link: string;
  referral_msg_header: string;
  referral_msg_body: string;
  page_url: string;
  result: string;
}

export interface IReferralsParams {
  email: string,
  ambassadorCustomMessage: string,
}


@Injectable()
export class ReferralModal {
  private referralUrl: string = `dashboard_upsell/earn_cash_referral`;
  private readonly endpoint: string = 'referrer/info';
  private component = null;

  constructor(
    @Inject(ServerApi) private api,
  ) {}

  public get(): Observable<IReferralInfo> {
    return this.api
      .get(this.endpoint)
      .pipe(map(this.transformData))
    ;
  }

  public show(...args) {
    if (!this.component) return;
    return this.component.show(...args);
  }

  public clear(...args) {
    if (!this.component) return;
    return this.component.clear(...args);
  }

  public registerComponent(component) {
    this.component = component;
  }

  public saveReferralsToMarketo(params: IReferralsParams[]): Observable<any> {
    return this.api.post(this.referralUrl, {
      input: params,
    });
  }

  private transformData(res: HttpResponse<IReferralInfo>): IReferralInfo {
    const data: IReferralInfo = extractResponseBody(res);

    const referrarInfo: IReferralInfo = {
      referrer_link: data.referrer_link,
      referral_msg_header: data.referral_msg_header,
      referral_msg_body: data.referral_msg_body,
      page_url: data.page_url,
      result: data.result,
    };

    return referrarInfo;
  }
}
